module.exports = __webpack_public_path__ + "downloads/npc-pop-data.9f1493fa.xlsx";